var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "895px",
    height: "767px",
    viewBox: "0 0 895 767",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "party") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "party",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.53275,499.81936 L136.85502,498.72951 C151.039123,476.880059 147.333018,447.976172 128.09525,430.41213 C127.28519,429.67287 126.44925,428.95513 125.61381,428.23733 C123.164114,426.290675 120.948754,424.06614 119.01224,421.60842 C116.64164,418.35549 114.83939,413.30373 116.88871,408.88186 L118.70316,409.72366 C117.01859,413.35744 118.5933,417.63772 120.62845,420.43066 C122.473407,422.763853 124.583632,424.874403 126.91654,426.71972 C127.76761,427.45116 128.61869,428.18163 129.44388,428.93554 C149.403596,447.159773 153.248864,477.148889 138.53275,499.81936 L138.53275,499.81936 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.93314,739.46291 L857.25541,738.37307 C871.439235,716.524065 867.733574,687.620815 848.49662,670.05666 C847.68412,669.31545 846.8472,668.59666 846.01029,667.87795 C843.562362,665.932088 841.348353,663.708904 839.41263,661.25295 C837.04252,658.00002 835.23978,652.94826 837.28963,648.52541 L839.10408,649.36721 C837.41951,653.00198 838.99373,657.28127 841.02986,660.07521 C842.873414,662.406852 844.98199,664.516082 847.31306,666.36036 C848.1656,667.09279 849.01814,667.82521 849.84529,668.58009 C869.805414,686.803797 873.650359,716.793214 858.93318,739.46291 L858.93314,739.46291 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.83935,614.08496 C692.684705,568.330451 642.386713,543.873809 593.95312,556.27832 C591.92578,556.79786 589.86572,557.39258 587.87402,557.9668 C582.31445,559.57227 576.56591,561.23145 570.65283,561.52442 C563.26611,561.88477 553.69091,559.59473 549,552.05664 L550.69824,551 C554.93164,557.80274 563.73632,559.86719 570.55424,559.52637 C576.23442,559.24512 581.86967,557.61817 587.31938,556.0459 C589.32573,555.4668 591.39995,554.86719 593.45708,554.34082 C642.838328,541.693178 694.120694,566.62837 714.66948,613.27832 L712.83935,614.08496 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.83935,287 C792.684705,246.384099 742.386713,224.674139 693.95312,235.685521 C691.92578,236.146713 689.86572,236.674641 687.87402,237.184371 C682.31445,238.609534 676.56591,240.082374 670.65283,240.342441 C663.26611,240.662321 653.69091,238.629471 649,231.937971 L650.69824,231 C654.93164,237.038736 663.73632,238.871332 670.55424,238.568789 C676.23442,238.319125 681.86967,236.874895 687.31938,235.479204 C689.32573,234.965142 691.39995,234.432873 693.45708,233.965618 C742.838328,222.738411 794.120694,244.873175 814.66948,286.283952 L812.83935,287 Z",
    id: "Path",
    fill: "#575A89",
    transform: "translate(731.834740, 259.000000) rotate(16.000000) translate(-731.834740, -259.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.89993,301.64455 L489.93313,301.28127 C499.015709,252.115962 471.194059,203.597313 424.17386,186.60256 C422.2056,185.89114 420.168,185.22366 418.19779,184.57815 C412.69879,182.77688 407.01273,180.91409 401.96,177.82961 C395.6431,173.97361 389.023,166.69241 389.38627,157.82034 L391.38427,157.90234 C391.05664,165.90722 397.17089,172.56298 403.00195,176.12255 C407.85644,179.08593 413.43017,180.91161 418.82031,182.67773 C420.80468,183.32763 422.85693,183.99999 424.85351,184.72167 C472.793592,202.04934 501.159629,251.517136 491.89993,301.64455 L491.89993,301.64455 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65185,391.54196 C153.21771,407.09883 137.23039,414.09107 124.18062,408.73486 C123.99537,408.66212 123.80841,408.58286 123.62749,408.50212 L123.41954,409.22301 C123.412509,409.250241 123.40332,409.276869 123.39206,409.30264 C123.145837,410.16947 122.496642,410.864325 121.648521,411.168808 C120.800399,411.473292 119.857488,411.350017 119.11615,410.83773 L115.77056,408.64241 C115.00124,408.132208 114.47437,407.329259 114.312564,406.420425 C114.150759,405.511592 114.36813,404.57614 114.91409,403.83177 L114.96255,403.77133 L115.52369,403.05433 L115.64832,402.89193 C105.79802,392.64632 104.07702,374.36516 112.31587,359.1685 C121.66352,341.92666 140.28337,335.19679 153.90857,344.13742 C167.53377,353.07805 170.9995,374.30012 161.65185,391.54196 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "translate(131.172320, 349.803563) rotate(-30.313480) translate(-131.172320, -349.803563) ",
    cx: 131.17232,
    cy: 349.803563,
    rx: 8.53843,
    ry: 3.0914
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.41954,409.22301 C203.412509,409.250241 203.40332,409.276869 203.39206,409.30264 L194.96255,403.77133 L195.52369,403.05433 L204.18062,408.73486 C203.99537,408.66212 203.80841,408.58286 203.62749,408.50212 L203.41954,409.22301 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D0CDE1",
    cx: 447.06693,
    cy: 738.54732,
    rx: 447.06693,
    ry: 28.06139
  }), /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(150.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FBBEBE",
    points: "181.443 502.54187 182.315652 523.43587 200.635 521.23587 198.890489 500.34287"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FBBEBE",
    points: "92.371 478.34987 93.2436521 499.24287 111.563 497.04387 109.818489 476.15087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86734,232.57693 L107.558464,384.32923 L86.32293,481.09885 L120.299807,496.49401 L153.214855,400.82407 L164.894389,316.15067 L173.388598,400.82407 L174.45037,507.49056 L226.47738,504.19156 L214.038728,295.3133 C212.43869,268.444313 205.465864,242.21269 193.562313,218.28142 L112.86734,232.57693 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.896122,515.73797 C183.896122,515.73797 176.736838,506.94073 176.736838,510.23969 C176.736838,513.53865 172.64583,545.42864 172.64583,545.42864 C172.64583,545.42864 200.260181,554.22587 200.260181,559.72415 C200.260181,565.22243 240.147574,574.01965 239.124824,563.02315 C238.102074,552.02665 203.328439,510.23973 203.328439,510.23973 C203.328439,510.23973 189.009889,508.04038 183.896122,515.73797 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6952159,491.67847 C94.6952159,491.67847 92.5664448,480.22641 91.0857137,483.09432 C89.6049826,485.96223 71.8187,511.51148 71.8187,511.51148 C71.8187,511.51148 91.3113326,533.83297 88.8434838,538.61282 C86.375635,543.39267 116.286568,572.23582 120.354074,562.13264 C124.42158,552.02946 113.658671,497.22457 113.658671,497.22457 C113.658671,497.22457 102.491159,487.70404 94.6952159,491.67847 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    points: "95.322 97.05887 152.451985 102.87987 171.495 47.57887 116.802987 33.53987"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FBBEBE",
    cx: 142.65446,
    cy: 54.98272,
    rx: 28.29033,
    ry: 30.79033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.530648,73.67685 C125.530648,73.67685 125.530648,94.57029 110.74967,103.36752 C95.9686914,112.16475 146.22402,122.06165 146.22402,122.06165 L151.15101,103.36752 C151.15101,103.36752 136.370031,95.66994 149.180212,78.07547 L125.530648,73.67685 Z",
    id: "Path",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.713605,97.86923 C150.713605,97.86923 131.445836,110.34381 115.304847,99.15808 L108.632187,97.86923 L88.6435086,102.26785 L79.17519,139.6561 L114.944402,233.12674 C114.944402,233.12674 177.014489,244.12328 189.63892,219.93088 L182.274664,120.96198 L162.286024,95.66994 L150.713605,97.86923 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#575A89",
    points: "162.940302 98.96887 196.921725 48.38487 193.832419 42.88687 149.553 18.69387 149.553 3.29887 218.546862 23.09287 223.215 30.99187 182.505278 125.36087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#575A89",
    points: "86.271 103.36787 84.1924654 102.26787 32.2215394 100.06887 71.7193676 63.77987 59.2462697 47.28487 0 94.56987 0 105.56687 84.1924654 142.95487"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.13055,52.23359 L68.6263254,47.83497 C68.6263254,47.83497 82.5458491,25.84188 88.1136518,34.63912 C93.6814545,43.43636 75.1221009,59.93117 75.1221009,59.93117 L64.9144514,64.32979 L62.13055,52.23359 Z",
    id: "Path",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85204,6.59793 L137.119384,1.42108547e-14 C137.119384,1.42108547e-14 104.921389,3.299 108.82416,10.99654 C112.726931,18.69408 135.167981,12.0962 135.167981,12.0962 L147.85204,16.49482 L147.85204,6.59793 Z",
    id: "Path",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.10343,25.26523 C120.10343,25.26523 106.633945,29.97654 105.949984,48.58252 C105.880495,51.5582889 106.195004,54.5302434 106.884953,57.41752 C107.643381,60.79038 108.130951,68.04772 102.253132,77.53152 C98.317304,83.7929655 94.7218122,90.2827874 91.4838512,96.96995 L91.44171,97.05838 L106.234842,98.99873 L109.380359,73.26849 C110.905373,60.7938562 114.172444,48.6228062 119.076468,37.14689 L119.178839,36.90733 C119.178839,36.90733 125.650837,49.51965 138.594824,49.51965 L133.971971,44.66876 C133.971971,44.66876 154.312528,53.40036 161.709099,53.40036 C161.709099,53.40036 167.256515,57.28107 161.709099,63.10214 C156.161683,68.92321 145.066822,82.50571 151.538782,93.17767 C158.010742,103.84963 152.463345,106.76016 152.463345,106.76016 L162.633662,100.93909 L167.256515,98.02856 L167.256515,101.90923 L191.295363,98.99869 C191.295363,98.99869 197.767352,98.02852 183.898793,81.53549 C183.898793,81.53549 180.236573,75.1307 181.838827,69.60666 C183.155404,65.408465 183.501384,60.9418551 182.848196,56.57566 C179.741275,38.38806 167.551466,2.22869 120.10343,25.26523 Z",
    id: "Path",
    fill: "#2F2E41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M497.98476,710.72479 C497.86466,710.52855 495.03301,705.80044 494.05131,695.98242 C493.15086,686.97489 493.72987,671.79201 501.60391,650.61313 C516.52106,610.49113 498.16617,578.11856 497.97862,577.79613 L498.88418,577.27078 C502.41839,584.033934 504.971271,591.266009 506.46591,598.74912 C510.162846,616.173742 508.816654,634.291143 502.5851,650.97804 C487.69351,691.03153 498.7646,709.9925 498.87805,710.17954 L497.98476,710.72479 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D0CDE1",
    cx: 492.15179,
    cy: 568.6373,
    r: 6.80291
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D0CDE1",
    cx: 513.60713,
    cy: 593.75575,
    r: 6.80291
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D0CDE1",
    cx: 498.9547,
    cy: 610.50139,
    r: 6.80291
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D0CDE1",
    cx: 516.74694,
    cy: 624.63051,
    r: 6.80291
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D0CDE1",
    cx: 493.72169,
    cy: 646.60916,
    r: 6.80291
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.09451,710.9752 C502.09451,710.9752 495.29159,694.22956 515.70034,681.67034 L502.09451,710.9752 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.72798,710.67144 C493.72798,710.67144 490.63191,692.86385 466.66887,693.01644 L493.72798,710.67144 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.657122,473.800093 C641.121122,517.531173 605.299852,546.853633 569.197802,544.441983 C568.687332,544.415583 568.168562,544.374983 567.664012,544.326173 L567.588832,546.207653 C567.588018,546.278538 567.581453,546.34924 567.569202,546.419063 C567.41785,548.748527 566.232435,550.888165 564.337732,552.251768 C562.443029,553.61537 560.037702,554.059961 557.780752,553.463733 L548.015242,550.887653 C545.790165,550.303229 543.93567,548.768017 542.946043,546.691203 C541.956416,544.614389 541.932223,542.207016 542.879912,540.110733 L542.964142,539.928403 L543.928932,537.776213 L544.141252,537.290703 C513.043092,520.699823 497.380572,478.530283 508.649442,435.811783 C521.434892,387.344183 564.031572,356.559963 603.802442,367.051263 C643.573312,377.542563 665.442522,425.332493 652.657122,473.800093 Z",
    id: "Path",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "translate(549.107921, 399.066602) rotate(-45.222380) translate(-549.107921, -399.066602) ",
    cx: 549.107921,
    cy: 399.066602,
    rx: 22.59238,
    ry: 7.56305
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.50553,99.78661 C661.16353,123.60805 674.95695,163.2854 660.69068,192.97861 C660.49575,193.40094 660.28554,193.82573 660.07282,194.23582 L661.70557,194.90527 C661.767606,194.928717 661.827693,194.957028 661.88527,194.98994 C663.862314,195.801182 665.353051,197.481148 665.923391,199.540645 C666.493731,201.600142 666.079556,203.807639 664.80147,205.52033 L659.24721,212.93266 C657.936649,214.63212 655.966973,215.696215 653.827193,215.860763 C651.687413,216.025311 649.578201,215.27488 648.02321,213.79578 L647.89086,213.66596 L646.31872,212.15849 L645.96227,211.82292 C620.88353,232.72592 578.45488,232.36292 544.59941,209.09301 C506.18764,182.69146 493.38457,136.8249 516.00473,106.63757 C538.62489,76.45024 588.09375,73.38505 626.50553,99.78661 Z",
    id: "Path",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "translate(525.458900, 166.773468) rotate(-25.526460) translate(-525.458900, -166.773468) ",
    cx: 525.4589,
    cy: 166.773468,
    rx: 7.07916,
    ry: 20.56631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.70557,194.90528 C661.767606,194.928727 661.827693,194.957038 661.88527,194.98995 L647.89084,213.66595 L646.3187,212.15848 L660.6907,192.9786 C660.49577,193.40093 660.28556,193.82572 660.07284,194.23581 L661.70557,194.90528 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.67601,48.10198 C432.5968,84.52941 427.87658,126.22213 402.19952,146.79998 C401.84152,147.09611 401.46866,147.38785 401.0999,147.66527 L402.28111,148.9736 C402.32685,149.021518 402.368734,149.072975 402.40637,149.12749 C403.836393,150.71227 404.453119,152.869312 404.076963,154.970502 C403.700807,157.071693 402.374056,158.880812 400.48305,159.87106 L392.27841,164.14687 C390.363871,165.111174 388.130243,165.218499 386.132068,164.442199 C384.133894,163.6659 382.558566,162.078778 381.79719,160.07487 L381.73409,159.90078 L380.96953,157.86392 L380.79353,157.4077 C349.17658,165.39765 311.12237,146.73941 290.68599,111.15545 C267.49926,70.78255 275.78546,23.94375 309.19949,6.53017 C342.61352,-10.88341 388.48928,7.72908 411.67601,48.10198 Z",
    id: "Path",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "translate(291.732202, 64.773026) rotate(-89.897720) translate(-291.732202, -64.773026) ",
    cx: 291.732202,
    cy: 64.7730261,
    rx: 20.54305,
    ry: 7.07116
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.28111,148.97362 C402.32685,149.021538 402.368734,149.072995 402.40637,149.12751 L381.73409,159.90079 L380.96953,157.86393 L402.19953,146.8 C401.84153,147.09613 401.46867,147.38787 401.09991,147.66529 L402.28111,148.97362 Z",
    id: "Path",
    fill: "#575A89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.09341,633.56675 C875.78908,648.88419 860.04782,655.76881 847.1989,650.49504 C847.0165,650.42341 846.83242,650.34537 846.65428,650.26588 L846.44954,650.97567 C846.442616,651.002484 846.433568,651.028703 846.42248,651.05408 C846.180046,651.907568 845.540842,652.591728 844.705774,652.891524 C843.870706,653.19132 842.942308,653.069942 842.21238,652.56554 L838.91828,650.40401 C838.160801,649.90166 837.642041,649.111069 837.482725,648.216223 C837.32341,647.321378 837.537434,646.400324 838.07499,645.66741 L838.12271,645.6079 L838.67521,644.9019 L838.79792,644.742 C829.09923,634.65408 827.40472,616.65429 835.51677,601.69153 C844.72054,584.71506 863.05377,578.08877 876.4693,586.8918 C889.88483,595.69483 893.29719,616.59028 884.09341,633.56675 Z",
    id: "Path",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "translate(852.116477, 592.473617) rotate(-30.313352) translate(-852.116477, -592.473617) ",
    cx: 852.116477,
    cy: 592.473617,
    rx: 8.40702989,
    ry: 3.0438272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.44954,650.97567 C846.442616,651.002484 846.433568,651.028703 846.42248,651.05408 L838.12271,645.6079 L838.67521,644.9019 L847.1989,650.49501 C847.0165,650.42338 846.83242,650.34534 846.65428,650.26585 L846.44954,650.97567 Z",
    id: "Path",
    fill: "#575A89"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.75cbfe2d6d805abe6c57a971472bdc4a.svg";
export { ForwardRef as ReactComponent };